var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWbnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m23.207 14.877-.015-3.17h.012l-2.693-1.585-4.614 2.72-4.587-2.72-2.692 1.585v3.17l4.615 2.708v5.429l2.68 1.57 2.68-1.57v-5.429l4.614-2.707zM15.897 2l-7.28 4.293 2.68 1.585 4.6-2.72 4.616 2.72 2.68-1.585L15.897 2zM6.696 21.416 6.68 16l-2.678-1.584v8.6l7.294 4.278v-3.17l-4.601-2.708zM6.68 13.74v-3.155l2.693-1.586L6.68 7.413 4 8.999v3.155l2.68 1.585zm9.218-6.326-2.68 1.585 2.68 1.585 2.693-1.586-2.692-1.586zm-4.602 11.294-2.68-1.586v3.17l2.68 1.572v-3.156zm4.602 8.136-2.68-1.585v3.155L15.898 30l2.693-1.585v-3.156l-2.692 1.584zm9.216-19.43-2.68 1.585 2.68 1.585v3.155l2.693-1.585V9l-2.693-1.586zm2.695 7L25.128 16l-.016 5.416-4.6 2.706v3.17l7.295-4.278v-8.6zm-4.618 5.88-2.68 1.57v-3.156l2.68-1.586v3.17z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWbnb);
export default __webpack_public_path__ + "static/media/WBNB.bbc95015576c7b5ea49a80365ed718d8.svg";
export { ForwardRef as ReactComponent };